export const appConfig = {
    baseUrlDev: import.meta.env.VITE_BASE_URL_DEV,
    baseUrlProd: import.meta.env.VITE_BASE_URL_PROD,
};
